import React from "react";
import { Card } from "react-bootstrap";
import useLanguage from "services/useLanguage";
import localization from "services/localization";
import PromptCard from "./PromptCard";
import { icons, Shield } from "lucide-react";

export function PromptCategoryCard({
  category,
  prompts = [],
  onPromptClick = () => {},
  onFavoriteToggle = () => {},
}) {
  const currentLang = useLanguage();

  const IconComponent =
    category.icon && icons[category.icon] ? icons[category.icon] : Shield;

  return (
    <Card
      className="category-card shadow-md transition-shadow backdrop-blur border  mb-4 p-3 rounded-2xl"
      style={{ height: "28rem", width: "60rem" }}
    >
      <div className="flex items-center gap-4 p-4 border-gray-200">
        <div className="main-icon flex h-12 w-12 items-center justify-center rounded-xl shadow-md">
          <IconComponent size={28} />
        </div>

        {/* Title & Description */}
        <div className="flex-1">
          <h3
            className="card-title"
            title={
              category.title?.[currentLang] ||
              category.title?.It ||
              category.title?.En ||
              "Unnamed Category"
            }
          >
            {category.title?.[currentLang] ||
              category.title?.It ||
              category.title?.En ||
              "Unnamed Category"}
          </h3>
          <p
            className="category-description mt-1"
            title={
              category.description?.[currentLang] ||
              category.description?.It ||
              category.description?.En
            }
          >
            {category.description?.[currentLang] ||
              category.description?.It ||
              category.description?.En}
          </p>
        </div>
      </div>

      {/* Prompts Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 p-4 overflow-y-auto scrollbar-hide">
        {prompts.map((prompt) => (
          <PromptCard
            key={prompt.id}
            item={prompt}
            onItemClick={onPromptClick}
            onFavoriteToggle={onFavoriteToggle}
          />
        ))}
        {prompts.length === 0 && (
          <div className="text-gray-400 italic col-span-full text-center">
            {localization.noPrompts || "No prompts in this category"}
          </div>
        )}
      </div>
    </Card>
  );
}
